import React from 'react';
import { useFormContext } from 'react-hook-form';
import { EmptyState } from '../../../../../../../../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { Box } from '../../../../../../../../../../CommonComponents/OPL/Box/Box';
import { AllocationContent } from '../AllocationContent/AllocationContent';
import { useNonSpecificPositions } from './useNonSpecificPositions';
import { AllocationTaxStatusDTO, TaxStatusDTO } from '../../../../../../../../api/useAccountsQuery';

interface Props {
  assetAllocationTaxStatus?: AllocationTaxStatusDTO | null;
}
export const NonSpecificPositions = ({ assetAllocationTaxStatus = null }: Props) => {
  const { data } = useNonSpecificPositions({ assetAllocationTaxStatus });

  const { watch } = useFormContext();

  const [accountTaxStatus] = watch(['bankAccount.TaxStatus']);

  if (!data) {
    return (
      <Box py="24">
        <EmptyState />
      </Box>
    );
  }

  return (
    <AllocationContent
      chartValues={data.chartValues}
      assetAllocationTaxStatus={assetAllocationTaxStatus}
      readOnly={accountTaxStatus === TaxStatusDTO.Mix && assetAllocationTaxStatus === null}
    />
  );
};
